import Alert from '@amzn/meridian/alert';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Loader from '@amzn/meridian/loader';
import React from 'react';

import logo from '../../assets/logo.svg';
import { errorMessages } from '../../constants/errors';

interface PropType {
  error: boolean;
  isErrorBoundaryFallback?: boolean;
}

const PreLoginLandingPage = (props: PropType) => {
  const { error, isErrorBoundaryFallback } = props;
  return (
    <Column height="100vh" alignmentHorizontal="center" alignmentVertical="center">
      <Box>
        <Column alignmentHorizontal="center" spacing="500">
          <img width="230rem" src={logo} alt="Smartbiz Logo" />
          {error ? (
            <Alert
              toast={true}
              type="error"
              width={800}
              title={
                isErrorBoundaryFallback ? 'Something went wrong!' : 'Unable to Reach Sign-In Page'
              }
            >
              {isErrorBoundaryFallback ? errorMessages.errorBoundary : errorMessages.preLoginError}
            </Alert>
          ) : (
            <Loader type="linear" size="small" />
          )}
        </Column>
      </Box>
    </Column>
  );
};

export default PreLoginLandingPage;
